<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-header bordered">
            <div class="form-group row mb-0">
              <div class="col-6 d-flex align-items-center">
                <label class="radio-title" style="width:100px" for="city">ایمیل</label>
                <input type="text" class="form-control" id="email" />
              </div>
              <div class="col-6 d-flex align-items-center">
                <label class="radio-title" style="width:100px" for="city">نام کاربری</label>
                <input type="text" class="form-control" id="username" />
              </div>
              <div class="row">
                <div class="col-4 d-flex align-items-center">
                  <label class="radio-title" style="width:100px" for="city">تایید هویت</label>
                  <select class="custom-select form-control" name="isVerified" id="isVerified">
                    <option value>همه</option>
                    <option value="1">انجام شده</option>
                    <option value="0">انجام نشده</option>
                  </select>
                </div>
                <div class="col-4 d-flex align-items-center">
                  <label class="radio-title" style="width:100px" for="city">وضعیت</label>
                  <select class="custom-select form-control" name="isActive" id="isActive">
                    <option value>همه</option>
                    <option value="1">فعال</option>
                    <option value="0">غیر فعال</option>
                  </select>
                </div>
                <div class="col-4 d-flex align-items-center">
                  <button class="btn btn-success btn-shadow" @click="search()">
                    جستجو
                  </button>
                </div>
                <div class="col-4 d-flex align-items-center mt-2">
                  <button class="btn btn-primary btn-shadow" @click="downloadUserNumbersExcel()">
                    دانلود اکسل شماره کاربران
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام کاربری</th>
                    <th>ایمیل</th>
                    <th>xp</th>
                    <th>بازی آنلاین</th>
                    <th>بازی لیگ</th>
                    <th>بازی مستر</th>
                    <th>کل بازی ها</th>
                    <th>حساب کاربری</th>
                    <th>وضعیت</th>
                    <th>اشتراک</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in userList" :key="user._id">
                    <td>{{ user.username }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.xp }}</td>
                    <td>
                      {{ user.totalGames }} / <span class="text-green">{{ user.totalWins }}</span>
                    </td>
                    <td>
                      {{ user.totalLeagueGames }} / <span class="text-green">{{ user.totalLeagueWins }}</span>
                    </td>
                    <td>
                      {{ user.totalMasterGames }} / <span class="text-green">{{ user.totalMasterWins }}</span>
                    </td>
                    <td>{{ user.totalMasterGames + user.totalLeagueGames + user.totalGames }}</td>
                    <td>{{ user.isVerified ? 'تایید شده' : 'تایید نشده' }}</td>
                    <td>{{ user.isActive ? 'فعال' : 'غیر فعال' }}</td>
                    <td>{{ new Date(user.licenseExpireDate).toLocaleDateString('fa-IR') }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/user', query: { id: user._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row" style="padding:9px 10px">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_info" id="sorting-table_info" role="status" aria-live="polite">
                    {{ `صفحه ${page.current} از ${page.total} - تعداد کل: ${page.count} ` }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="direction:ltr">
                  <div class="dataTables_paginate paging_simple_numbers" id="sorting-table_paginate">
                    <ul class="pagination">
                      <!-- disabled -->
                      <li class="paginate_button page-item previous" id="sorting-table_previous">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="0"
                          tabindex="0"
                          class="page-link"
                          @click="getUsers({ page: page.pre })"
                          >قبلی</a
                        >
                      </li>
                      <li class="paginate_button page-item">
                        <a aria-controls="sorting-table" data-dt-idx="1" tabindex="0" class="page-link">{{
                          page.current
                        }}</a>
                      </li>
                      <li class="paginate_button page-item next" id="sorting-table_next">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="3"
                          tabindex="0"
                          class="page-link"
                          @click="getUsers({ page: page.next })"
                          >بعدی</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import userService from '../../../services/userService';
export default {
  name: 'users',
  data() {
    return {
      userList: [],
      lastConditions: {
        isActive: '',
        isVerified: '',
        email: '',
        username: '',
      },
      page: {
        next: '',
        pre: '',
        current: '',
        total: '',
        count: '',
      },
    };
  },

  created() {
    this.getUsers({ page: 1 });
  },

  methods: {
    async getUsers({ page = 1, condition = {} }) {
      if (page == '' || parseInt(page) < 1) return;
      if (this.lastConditions.isActive != '') condition.isActive = this.lastConditions.isActive == '1';
      if (this.lastConditions.isVerified != '') condition.isVerified = this.lastConditions.isVerified == '1';
      if (this.lastConditions.email != '') condition.email = this.lastConditions.email;
      if (this.lastConditions.username != '') condition.username = this.lastConditions.username;
      const res = await userService.getUsers({ condition, page });
      this.userList = res.users;
      this.pageController(res);
    },
    pageController(res) {
      this.page.count = res.count;
      this.page.current = res.currentPage;
      this.page.total = res.totalPages;
      if (this.page.current == this.page.total) {
        this.page.next = '';
      } else {
        this.page.next = parseInt(this.page.current) + 1;
      }
      if (this.page.current == 1) {
        this.page.pre = '';
      } else {
        this.page.pre = this.page.current - 1;
      }
    },
    search() {
      this.lastConditions = {
        isActive: document.getElementById('isActive').value,
        isVerified: document.getElementById('isVerified').value,
        email: document.getElementById('email').value,
        username: document.getElementById('username').value,
      };
      this.getUsers({});
    },
    async downloadUserNumbersExcel() {
      const condition = {};
      if (this.lastConditions.isActive != '') condition.isActive = this.lastConditions.isActive == '1';
      if (this.lastConditions.isVerified != '') condition.isVerified = this.lastConditions.isVerified == '1';
      if (this.lastConditions.email != '') condition.email = this.lastConditions.email;
      if (this.lastConditions.username != '') condition.username = this.lastConditions.username;

      const fileData = await userService.exportUserNumbersExcel({ condition });
      const url = window.URL.createObjectURL(
        new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `user-numbers-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
